import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import determinarPaginaAtualTomadores from '../../actions/cteos/tomador/determinarPaginaAtualTomador'
import alterarRegistrosPorPaginaTomadores from '../../actions/cteos/tomador/alterarRegistrosPorPaginaTomadores'

export class PaginacaoTomador extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtualTomadores}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPaginaTomadores}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    determinarPaginaAtualTomadores,
    alterarRegistrosPorPaginaTomadores
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    tomadores: state.tomador.tomadores,
    total: state.tomador.total,
    paginaAtual: state.tomador.paginaAtualTomadores,
    registrosPorPagina: state.tomador.registrosPorPaginaTomadores
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoTomador)
